import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CategorySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CategorySVG;
